import { PurchasedProductEntityModel } from './PurchasedProductEntityModel';

const PURCHASE_SOURCES = ["Purchase Order", "None", "Purchase Return"];

export class PurchaseEntityModel {
    constructor(purchase) {

        const typeOk = PURCHASE_SOURCES.includes(purchase.type);
        this.purchase_from = typeOk ? purchase.type : "None";
        this.date = purchase.date ? purchase.date : "";
        this.remark = purchase.remark != null ? purchase.remark : "";
        const whId = Number(purchase.wareHouse_id);
        const supId = Number(purchase.supplier_id);
        this.wareHouse_id = Number.isFinite(whId) ? whId : null;
        this.supplier_id = Number.isFinite(supId) ? supId : null;
        const disc = Number(purchase.discountAmount);
        this.discount_amount = Number.isFinite(disc) ? disc : 0;
        if (this.purchase_from === "Purchase Order") {
            this.purchase_order_id = purchase.purchase_order_id;
        }
        if (this.purchase_from === "Purchase Return") {
            this.purchase_return_id = purchase.purchase_return_id;
        }



        this.products = purchase.products.map((u, i, arr) => {
            return new PurchasedProductEntityModel(u);
        })


    }
}
